module.exports = __webpack_public_path__ + "static/media/Spring15min.101678a5.png";